import { css } from "@emotion/react"

interface InfoSectionProps {
    children: React.ReactNode
}

export const InfoSection = ({
    children
}: InfoSectionProps): React.ReactElement => {
    return (
        <div
            css={css`
                display: flex;
                flex-direction: column;
                gap: 16px;
            `}
        >
            {children}
        </div>
    )
}
